import { API_HOST } from './appConstants'

export const BASE_API = `${API_HOST}/api`

export const GET_SCREEN_CONTENT = screenId => `${BASE_API}/zones?filters[screens][screenId][$eq]=${screenId}`
